import styled from 'styled-components'

export const EssayQuestionInfoContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
`
